import { render } from "./PrivacyPolicy.vue?vue&type=template&id=a90bd0ec&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=a90bd0ec&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a90bd0ec"]])

export default __exports__